import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { newrelic } from "@jti/fe-clients";
import { isServerSide } from "@jti/fe-common";
import { CasCustomAttrsApi, getUser, LoyaltyApi } from "@jti/rest-api";
export const Survey = (props) => {
    const { scriptUrl } = props;
    const getScriptContent = async () => {
        const scriptContent = await fetch(scriptUrl);
        return scriptContent.text();
    };
    const getPointsAndComplaints = async (user) => {
        try {
            const casCustomAttrsApi = CasCustomAttrsApi.init();
            const loyaltyApi = LoyaltyApi.init();
            const [isUserHasComplaints, pointsHistory] = await Promise.all([
                casCustomAttrsApi.getIsUserHasComplaints(),
                loyaltyApi.getPointsHistory(user.uuid, user.ciam_token),
            ]);
            if (typeof window.QSI === "undefined") {
                window.QSI = {};
                window.QSI.config = {
                    externalReference: user.uuid,
                    availableComplaints: isUserHasComplaints,
                    ploomPoints: pointsHistory?.items.reduce((accumulator, item) => accumulator + item.points, 0),
                };
            }
            const scriptContent = await getScriptContent();
            const parser = new DOMParser();
            const code = parser.parseFromString(scriptContent, "text/html");
            if (isServerSide()) {
                newrelic.noticeError(new Error("document is not available"));
                return;
            }
            const scriptNode = document.createElement("script");
            scriptNode.innerHTML = code.getElementsByTagName("script")[0].text;
            document.head.appendChild(scriptNode);
        }
        catch (e) {
            console.log("getPointsAndComplaints Error ==>", e);
        }
    };
    useEffect(() => {
        const user = getUser();
        if (user.ciam_token && user.uuid) {
            getPointsAndComplaints(user);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _jsx("div", { children: "(Survey placeholder)" });
};
//# sourceMappingURL=Survey.js.map